import { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

// Streams the source HLS directly (no ffmpeg) for a fast preview. Logo/music are overlaid
// live here, not baked in until "Generate clip" runs the real pipeline in generateClip.js.
const ClipPreviewPlayer = ({ masterPlaylistUrl, clipStart, clipEnd, logoUrl, musicTrack }) => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const audioRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(false);
    const videoElement = document.createElement('video-js');
    videoElement.classList.add('vjs-big-play-centered');
    containerRef.current.appendChild(videoElement);

    const player = videojs(videoElement, {
      controls: true,
      fluid: true,
      preload: 'auto',
      sources: [{ src: masterPlaylistUrl, type: 'application/x-mpegURL' }],
      controlBar: false,
    });
    playerRef.current = player;

    player.one('loadeddata', () => {
      player.currentTime(clipStart);
      setReady(true);
    });
    player.on('play', () => audioRef.current?.play().catch(() => {}));
    player.on('pause', () => audioRef.current?.pause());
    player.on('timeupdate', () => {
      if (player.currentTime() >= clipEnd) {
        player.pause();
        player.currentTime(clipStart);
      }
    });

    return () => {
      player.dispose();
      playerRef.current = null;
    };
  }, [masterPlaylistUrl, clipStart, clipEnd]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const wasPlaying = playerRef.current && !playerRef.current.paused();
    audio.load();
    if (wasPlaying) audio.play().catch(() => {});
  }, [musicTrack]);

  return (
    <div className='position-relative w-100 h-100'>
      <div data-vjs-player className='w-100 h-100 parliament-live-video-player'>
        <div ref={containerRef} className='w-100 h-100' />
      </div>
      <img
        src={logoUrl}
        alt=''
        className='position-absolute'
        style={{ top: 16, left: 16, height: '25px', pointerEvents: 'none' }}
      />
      {musicTrack && <audio ref={audioRef} src={musicTrack.url} loop />}
      {!ready && (
        <div
          className='bg-main-white position-absolute w-100 h-100 flex-centered justify-content-center flex-column text-center px-3'
          style={{ top: 0, left: 0 }}
        >
          <img src={`${import.meta.env.VITE_APP_CDNURL}/images/loader.gif`} alt='Loading' />
          <p className='paragraph-p4 mt-3 mb-0'>Preparing preview…</p>
        </div>
      )}
    </div>
  );
};

export default ClipPreviewPlayer;
